import { AxiosRequestConfig } from "axios";

export enum ResponseFormat {
  Full = "FULL",
  Default = "DEFAULT",
  Brief = "BRIEF",
  BriefSanitized = "BRIEF_SANITIZED",
}

type TClientConfigParams = Omit<AxiosRequestConfig["params"], "format"> & {
  format?: ResponseFormat;
};

export interface IClientConfig extends AxiosRequestConfig {
  isMockApiOn?: boolean;
  params?: TClientConfigParams;
}
